import { BigNumber } from '@0x/utils'
import { AnyProvider } from 'app-lib/providerUtils'
import sushi from './sushi'
import univ3 from './univ3'
import { DEX, DexDataPayload, TradeType } from './types'

type RouteHandler = (provider: AnyProvider, payload: DexDataPayload) => Promise<[string, BigNumber]>

const routeHandlers: Record<Exclude<DEX, DEX.AUTO>, RouteHandler> = {
  [DEX.SUSHI]: sushi.getSushiRoute,
  [DEX.UNISWAPV3]: univ3.getUniswapV3Route,
}

/**
 * Search for the best route amoung all the dexes supported.
 * Note: this is very slow; not recommended to use.
 */
async function getAutoRoute(provider: AnyProvider, payload: DexDataPayload) {
  let result: [string, BigNumber] = ['0x', new BigNumber(0)]
  const dexes = Object.values(DEX).filter((dex) => dex !== DEX.AUTO) as unknown as Array<
    Exclude<DEX, DEX.AUTO>
  >
  for (const dex of dexes) {
    try {
      const dataSet = await routeHandlers[dex](provider, payload)
      if (payload.direction == TradeType.EXACT_INPUT) {
        if (new BigNumber(dataSet[1].toString()).gt(new BigNumber(result[1].toString()))) {
          result = dataSet
        }
      } else {
        if (result[1].toString() === '0') {
          result = dataSet
        }
        if (new BigNumber(dataSet[1].toString()).lt(new BigNumber(result[1].toString()))) {
          result = dataSet
        }
      }
    } catch (err) {
      console.error(
        `getAutoRoute: retrievePayload failed for dex ${dex}; params: ${JSON.stringify(payload)}`,
        err
      )
    }
  }
  return result
}

/**
 * @returns [loanDataBytes, AmountReceivedForTheSwap]
 */
async function getTradePayload(
  provider: AnyProvider,
  payload: DexDataPayload,
  dex: DEX
): Promise<[string, BigNumber]> {
  if (dex === DEX.AUTO) {
    return getAutoRoute(provider, payload)
  }
  try {
    const tradePayload = await routeHandlers[dex](provider, payload)
    return tradePayload
  } catch (err) {
    err.message += ` - getTradePayload: failed for dex ${dex}; params: ${JSON.stringify(payload)}`
    console.error(err)
    throw err
  }
}

export default {
  getTradePayload,
}
